{"n":48.49536298808635,"s":48.05454493778593,"e":17.46247744039427,"w":16.94732753698405,"zoom":11.9,"width":1400,"height":1800}